import type { DeleteAccountInfo } from '@/types/account';
import type { CommonResponse, EmptyResponse } from '@/types/responseModel';
import { Request } from '@/utils/request';

// 提交删除账号请求
export function proposeAccountDeletion() {
  return Request<EmptyResponse>({
    url: '/rest/os/deletion/propose/merchant/deletion',
    method: 'post'
  });
}

// 取消删除账号
export function cancelAccountDeletion() {
  return Request<EmptyResponse>({
    url: '/rest/os/deletion/cancel/merchant/deletion',
    method: 'post'
  });
}

// 获取删除账号期间信息
export function getAccountDeletion() {
  return Request<CommonResponse<DeleteAccountInfo>>({
    url: '/rest/os/deletion/get/merchant/deletion/info',
    method: 'get'
  });
}
